const initialState = {
  isLoading: false,
  totalRegistros: 0,
  movimentoInsumo: [],
  id: 0,
  idTipoMovimentoInsumo: 0,
  dataHora: '',
  idLoja: 0,
  idTotvsInsumo: 0,
  idTotvsProduto: 0,
  quantidade: 0,
  responsavel: '',
  excluido: false,
  page: 0,
  limit: 10,
  order: 'dataHora',
  direction: 'desc',
  term: ''
}

export function movimentoInsumo(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_MOVIMENTO_INSUMO':
      return {
        ...state,
        movimentoInsumo: action.movimentoInsumo,
        totalRegistros: action.totalRegistros
      }
    case 'MOVIMENTO_INSUMO_DETAIL':
      return {
        ...state,
        isLoading: false,
        id: action.movimentoInsumo.id,
        idTipoMovimentoInsumo: action.movimentoInsumo.idTipoMovimentoInsumo,
        dataHora: action.movimentoInsumo.dataHora,
        idLoja: action.movimentoInsumo.idLoja,
        idTotvsInsumo: action.movimentoInsumo.idTotvsInsumo,
        idTotvsProduto: action.movimentoInsumo.idTotvsProduto,
        quantidade: action.movimentoInsumo.quantidade,
        responsavel: action.movimentoInsumo.responsavel,
        excluido: action.movimentoInsumo.excluido
      }
    case 'MOVIMENTO_INSUMO_UPDATED':
      return state
    case 'MOVIMENTO_INSUMO_CLEAR':
      return {
        ...initialState,
        page: state.page,
        limit: state.limit,
        order: state.order,
        direction: state.direction,
        term: state.term
      }
    case 'MOVIMENTO_INSUMO_CLEAR_ALL':
      return {
        ...state,
        movimentoInsumo: []
      }
    case 'MOVIMENTO_INSUMO_HANDLE_ON_CHANGE':
      return {
        ...state,
        [action.props]: action.value
      }
    case 'MOVIMENTO_INSUMO_ISLOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'MOVIMENTO_INSUMO_NOTISLOADING':
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}
